/**
 * Onde uma oportunidade do cliente está: o nome do funil e o da etapa.
 *
 * A oportunidade que vem com a conversa traz só o valor cru da etapa
 * (`F_VENDAS_NOVO`). Os nomes saem das listas que a tela já tem: a das etapas,
 * em que cada uma diz de que funil é, e a dos funis. A tela não lê o prefixo do
 * valor, porque a convenção é do comercial (§17.1).
 */

import type { EtapaDoFunil, Funil } from '@cliqcrm/contracts';
import { nomeDaEtapa } from '@/entities/comercial/etapa';

export interface LugarDaOportunidade {
  /**
   * `null` quando a etapa não está na lista: ela saiu do funil, ou a lista
   * ainda não chegou. Mostrar o valor cru seria pôr código na tela.
   */
  readonly funil: string | null;
  readonly etapa: string | null;
}

export function lugarDaOportunidade(
  etapa: string | null,
  etapas: readonly EtapaDoFunil[],
  funis: readonly Funil[],
): LugarDaOportunidade {
  const daLista = etapa ? etapas.find((e) => e.valor === etapa) : undefined;
  if (!daLista) return { funil: null, etapa: null };
  return {
    funil: funis.find((f) => f.chave === daLista.funil)?.nome ?? null,
    etapa: nomeDaEtapa(daLista.rotulo),
  };
}

/** `no funil "Vendas", na etapa "Proposta"`, ou o pedaço que se sabe. Vazio sem nada. */
export function fraseDoLugar(lugar: LugarDaOportunidade): string {
  if (lugar.funil && lugar.etapa) return `no funil "${lugar.funil}", na etapa "${lugar.etapa}"`;
  if (lugar.etapa) return `na etapa "${lugar.etapa}"`;
  return '';
}
